import * as angular from 'angular';

import { ReportDataService } from '../../services/report-data-service';
import template from './report-settings.html';

export default class ReportSettingsController implements angular.IController {
  static $inject = ['$scope', '$rootScope', '$stateParams', 'ToastService', 'ReportDataService'];

  report: any;
  owner: any;
  onSubmit: () => void;
  onCancel: () => void;
  toggles: any;
  theme: { value; options };
  manualRunDisabled: boolean;

  private get form() {
    return (
      this.report._resource.hasForm('update_settings') && this.report._resource.forms('update_settings')._inputs.report
    );
  }

  constructor(
    private $scope,
    private $rootScope,
    private $stateParams,
    private AlertService,
    private reportDataService: ReportDataService
  ) {}

  $onInit() {
    this.toggles = {
      fullWidth: this.report.full_width,
      manualRunDisabled: this.report.manual_run_disabled,
      drillAnywhereEnabled: this.report.drill_anywhere_enabled,
    };

    if (this.form) {
      this.theme = angular.copy(this.form.theme);
      this.manualRunDisabled = this.form.manual_run_disabled;
    }
  }

  submit() {
    const settings = {
      'report.full_width': this.toggles.fullWidth,
      'report.manual_run_disabled': this.toggles.manualRunDisabled,
      'report.drill_anywhere_enabled': this.toggles.drillAnywhereEnabled,
      'report.theme': this.theme.value,
      includes: ['report_theme'],
    };
    this.report.saveReportSettings(settings).then(
      (report: any) => {
        this.AlertService.success('Report settings saved');
        this.reportDataService.updateReportSettingsSilently(report._resource);
        this.$rootScope.$broadcast('preview.update', {
          updateSettings: { full_width: report.full_width, theme: report.localTheme },
        });
      },
      () => {
        this.AlertService.error('Could not save report settings');
      }
    );

    this.onSubmit();
  }

  cancel() {
    this.onCancel();
  }

  toggleStatus(state: boolean, field): void {
    this.toggles[field] = state;
  }
}

const ReportSettingsComponent: angular.IComponentOptions = {
  bindings: {
    report: '<',
    owner: '<',
    onSubmit: '&',
    onCancel: '&',
  },
  controller: ReportSettingsController,
  controllerAs: 'ctrl',
  template: template,
};

angular.module('mode.components').component('reportSettings', ReportSettingsComponent);
